module.exports = __webpack_public_path__ + "static/media/avtar.cc6f9331.jpg";